import { SvgIcon, type SvgIconProps } from './svgIcon'

export const CrownPlusIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path
      d="M18.25 13.375C18.3881 13.375 18.5 13.4869 18.5 13.625V15.625H20.5C20.6381 15.625 20.75 15.7369 20.75 15.875V16.875C20.75 17.0131 20.6381 17.125 20.5 17.125H18.5V19.125C18.5 19.2631 18.3881 19.375 18.25 19.375H17.25C17.1119 19.375 17 19.2631 17 19.125V17.125H15C14.8619 17.125 14.75 17.0131 14.75 16.875V15.875C14.75 15.7369 14.8619 15.625 15 15.625H17V13.625C17 13.4869 17.1119 13.375 17.25 13.375H18.25Z"
      fill="white"
    />
    <path
      d="M12.8613 6.34375C12.8613 5.73945 12.3639 5.25 11.75 5.25C11.1361 5.25 10.6387 5.73945 10.6387 6.34375C10.6387 6.7375 10.8503 7.08203 11.167 7.27344L9.5752 10.4072C9.32239 10.9048 8.66626 11.0465 8.22461 10.6992L5.75 8.75C5.88889 8.5668 5.97266 8.33984 5.97266 8.09375C5.97266 7.48952 5.47512 7.00012 4.86133 7C4.24744 7 3.75 7.48945 3.75 8.09375C3.75 8.69805 4.24744 9.1875 4.86133 9.1875H4.88086L6.15039 16.0615C6.30317 16.8928 7.03928 17.5 7.90039 17.5H13.4025C13.5959 17.5 13.7527 17.343 13.7525 17.1495L13.75 15.2754C13.75 14.9992 13.9739 14.7754 14.25 14.7754H15.8008C15.9938 14.7752 16.1502 14.6188 16.1504 14.4258V12.875C16.1504 12.5989 16.3742 12.375 16.6504 12.375H17.739C17.9078 12.375 18.0525 12.2546 18.0832 12.0886L18.6191 9.1875H18.6387C19.2526 9.1875 19.75 8.69805 19.75 8.09375C19.75 7.48945 19.2526 7 18.6387 7C18.0249 7.00012 17.5273 7.48952 17.5273 8.09375C17.5273 8.33984 17.6111 8.5668 17.75 8.75L15.2754 10.6992C14.8337 11.0465 14.1776 10.9048 13.9248 10.4072L12.333 7.27344C12.6497 7.08203 12.8613 6.73477 12.8613 6.34375Z"
      fill="white"
    />
  </SvgIcon>
)
